import { Typography } from 'antd/lib';
import './index.less';

export default Typography;



// WEBPACK FOOTER //
// ./src/elements/typography/index.js